import React, { useMemo } from 'react';
import { Flex, Pane, Popup, PropertyGrid, Text } from '@leverege/ui-elements';
import { Attributes, AttributeSelector } from '@leverege/ui-attributes';
import { useValueChange } from '@leverege/ui-hooks';
import I18N from '@leverege/i18n';
import Model from "./ParentAttributeThresholdizer.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t,
  tIcon
} = I18N.ns('molten.ParentAttributeThresholdizerEditor');
export default function ParentAttributeThresholdizerEditor(props) {
  const {
    value,
    parentValue,
    objectType,
    relationship
  } = props;
  const onModelChange = useValueChange(Model, props);
  const parentRelationship = Model.nearestItemParentRelationship(relationship);
  const availAttributes = useMemo(() => {
    if (!parentRelationship) {
      return null;
    }
    const yAttr = Attributes.getAttribute(parentValue.yCoordinate?.attrName, objectType);
    if (!yAttr) {
      return [];
    }
    return Attributes.getAttributesFor(parentRelationship.objectType).filter(attr => {
      return attr.valueType === yAttr.valueType && attr.source?.custom !== true;
    });
  }, [parentValue, objectType, parentRelationship]);
  if (!parentRelationship) {
    return /*#__PURE__*/_jsx(Flex, {
      variant: "rowM",
      align: "center",
      children: /*#__PURE__*/_jsx(Text, {
        variant: "subtitle",
        children: t('noParentDescription')
      })
    });
  }
  if (availAttributes.length === 0) {
    return /*#__PURE__*/_jsxs(Flex, {
      variant: "rowM",
      align: "center",
      children: [/*#__PURE__*/_jsx(Text, {
        variant: "subtitle",
        children: t('noAttributes')
      }), /*#__PURE__*/_jsx(Popup, {
        title: t('help'),
        icon: tIcon('helpIcon'),
        children: /*#__PURE__*/_jsx(Pane, {
          variant: "infoPopup|formBody",
          children: /*#__PURE__*/_jsx(Text, {
            variant: "body",
            children: t('noAttrsDescription')
          })
        })
      })]
    });
  }
  return /*#__PURE__*/_jsx(PropertyGrid, {
    children: /*#__PURE__*/_jsx(PropertyGrid.Item, {
      label: t('attribute'),
      children: /*#__PURE__*/_jsx(AttributeSelector
      // className={S.attributeSelector}
      , {
        values: availAttributes,
        value: Model.getAttrName(value),
        onChange: onModelChange,
        eventData: "setAttrName"
      })
    })
  });
}